{
  "title": "Create Account",
  "subtitle": "Sign up to get started",
  "emailLabel": "Email",
  "passwordLabel": "Password",
  "confirmPasswordLabel": "Confirm Password",
  "signUpButton": "Sign Up",
  "requirementsText": "Must be 8+ characters with uppercase, lowercase, and numbers",
  "strengthLabel": "Strength: {{strength}}",
  "passwordStrength": {
    "tooShort": "Too short",
    "weak": "Weak",
    "fair": "Fair",
    "good": "Good",
    "strong": "Strong"
  },
  "alreadyHaveAccount": "Already have an account? ",
  "logIn": "Log in",
  "errors": {
    "invalidEmail": "Please enter a valid email address",
    "tooShort": "Password must be at least 8 characters",
    "needsUppercase": "Password must contain at least one uppercase letter",
    "needsLowercase": "Password must contain at least one lowercase letter",
    "needsNumber": "Password must contain at least one number",
    "noMatch": "Passwords do not match",
    "createFailed": "Failed to create account",
    "createFailedRetry": "Failed to create account. Please try again.",
    "genericError": "An error occurred. Please try again."
  }
}
